import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  IconButton,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "./Dialog/DialogComponents";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import { ReactComponent as DoctorWithPill } from "../../Assets/Icons/DoctorWithPill.svg";
import { ReactComponent as VideoIcon } from "../../Assets/Icons/VideoIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/Icons/CloseIcon.svg";
import { ReactComponent as ArrowNext } from "../../Assets/Icons/ArrowNext.svg";
import { ReactComponent as ArrowRight } from "../../Assets/Icons/ArrowRight.svg";
import { ReactComponent as CorrectIcon } from "../../Assets/Icons/CorrectIcon.svg";
import { START_UPDATE_FIRST_LOGIN_TOUR } from "../../Actions/UserAction";
import { START_GET_LOGIN_USER } from "../../Actions/UserAction";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import VideoDialog from "../Common/VideoDialog";
import clsx from "clsx";
import theme from "Theme/theme";
import { Navigate, useNavigate } from "react-router-dom";
import useViewport from "../../Hooks/useViewport";
const useStyles = makeStyles((theme) => ({
  rsDialog: {
    "& .MuiDialog-container": {
      "& .MuiPaper-root": {
        // borderRadius: "20px !important",
        borderRadius: "32px !important",
        maxWidth: "920px",
        height: "556px",
        padding: "10px 0px",
        background: theme.palette.primary.main,
        [theme.breakpoints.down(769)]: {
          height: "unset",
          maxWidth: "700px",
        },
        [theme.breakpoints.down(563)]: {
          top: "185px",
        },
        // [theme.breakpoints.down(430)]: {
        //   height: "360px",
        // },
        // "@media (max-height: 700px)": {
        //   height: "310px",
        // },
        "@media (max-height: 700px)": {
          top: "90px",
        },
      },
    },
  },
  ModalHeading: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    padding: "0px 10px",
  },
  closeIconBtn: {
    "&>button": {
      padding: "0px",
    },
    "&>svg": {
      width: "17px",
      height: "17px",
      fill: theme.palette.white.main,
      stroke: theme.palette.white.main,
      [theme.breakpoints.down(769)]: {
        width: "15px",
        height: "15px",
      },
      [theme.breakpoints.down(359)]: {
        width: "12px",
        height: "12px",
      },
    },
  },
  pageOneContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    "&>div:first-child": {
      marginLeft: "20px",
      marginRight: "30px",
      "&>svg": {
        width: "246px",
        height: "474px",
        [theme.breakpoints.down(769)]: {
          width: "200px",
          height: "400px",
        },
        [theme.breakpoints.down(625)]: {
          width: "160px",
          height: "370px",
        },
        [theme.breakpoints.down(553)]: {
          width: "135px",
          height: "300px",
        },
        [theme.breakpoints.down(405)]: {
          width: "100px",
          height: "250px",
        },
        [theme.breakpoints.down(385)]: {
          width: "95px",
          height: "213px",
        },
      },
    },
    "&>div:last-child": {
      "&>h1": {
        color: theme.palette.white.main,
        fontSize: "2.625rem",
        fontWeight: "500",
        marginTop: "60px",
        [theme.breakpoints.down(769)]: {
          fontSize: "2rem",
        },
        [theme.breakpoints.down(625)]: {
          fontSize: "1.8rem",
        },
        [theme.breakpoints.down(553)]: {
          fontSize: "1.4rem",
          marginTop: "43px",
        },
        [theme.breakpoints.down(445)]: {
          marginTop: "22px",
        },
        [theme.breakpoints.down(405)]: {
          marginTop: "30px",
          fontSize: "1.2rem",
        },
        [theme.breakpoints.down(385)]: {
          marginTop: "10px",
          fontSize: "1.2rem",
        },
      },
      "&>h2": {
        color: "black",
        fontSize: "2.625rem",
        fontWeight: "500",
        marginTop: "15px",
        [theme.breakpoints.down(769)]: {
          fontSize: "2rem",
        },
        [theme.breakpoints.down(625)]: {
          fontSize: "1.8rem",
        },
        [theme.breakpoints.down(553)]: {
          fontSize: "1.4rem",
        },
        [theme.breakpoints.down(440)]: {
          fontSize: "1.3rem",
          paddingRight:"10px"
        },
        [theme.breakpoints.down(405)]: {
          fontSize: "1.2rem",
          paddingRight:"10px"
        },
        [theme.breakpoints.down(385)]: {
          fontSize: "1.2rem",
          paddingRight:"35px"
        },
      },
    },
  },
  dialogContent: {
    padding: "0px !important",
    [theme.breakpoints.down(440)]: {
      paddingBottom: "40px !important",
    },
  },
  watchVideoContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: "20px",
    cursor: "pointer",
    [theme.breakpoints.down(359)]: {
      marginTop: "11px",
    },
    "&>h5": {
      fontSize: "1.125rem !important",
      color: theme.palette.white.main,
      fontWeight: "500",
      marginLeft: "8px",
      textDecoration: "underline",
      marginLeft: "25px",
      cursor: "pointer",
      [theme.breakpoints.down(769)]: {
        fontSize: "1rem !important",
      },
      [theme.breakpoints.down(625)]: {
        fontSize: "0.9rem !important",
      },
      [theme.breakpoints.down(553)]: {
        fontSize: "0.8rem  !important",
      },
      [theme.breakpoints.down(359)]: {
        fontSize: "0.6rem  !important",
      },
    },
  },
  watchVideo: {
    background: theme.palette.white.main,
    width: "178px",
    height: "48px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    [theme.breakpoints.down(769)]: {
      width: "unset",
      height: "unset",
      padding: "10px",
    },
    [theme.breakpoints.down(553)]: {
      padding: "8px",
    },
    "&>svg": {
      width: "19px",
      height: "19px",
      [theme.breakpoints.down(553)]: {
        width: "15px",
        height: "15px",
      },
      [theme.breakpoints.down(359)]: {
        width: "12px",
        height: "12px",
      },
    },
    "&>h5": {
      fontSize: "1.125rem !important",
      color: "black",
      fontWeight: "500",
      marginLeft: "8px",
      [theme.breakpoints.down(769)]: {
        fontSize: "1rem !important",
      },
      [theme.breakpoints.down(625)]: {
        fontSize: "0.9rem !important",
      },
      [theme.breakpoints.down(553)]: {
        fontSize: "0.8rem  !important",
      },
      [theme.breakpoints.down(359)]: {
        fontSize: "0.6rem  !important",
      },
    },
  },
  dontShowCheckbox: {
    marginTop: "35px",
    "&>label": {
      "&>span": {
        color: theme.palette.white.main,
        fontWeight: "500",
        fontSize: "1.125rem !important",
      },
      "&>.Mui-checked": {
        color: theme.palette.white.main,
      },
    },
  },
  pagination: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: "22px",
    position: "absolute",
    right: "20px",
    bottom: "20px",
    "&>h3": {
      color: theme.palette.white.main,
      fontWeight: "500",
      fontSize: "1.5rem !important",
      marginRight: "25px",
      [theme.breakpoints.down(769)]: {
        fontSize: "1.3rem !important",
      },
      [theme.breakpoints.down(625)]: {
        fontSize: "1.2rem !important",
      },
      [theme.breakpoints.down(553)]: {
        fontSize: "1rem !important",
      },
      [theme.breakpoints.down(405)]: {
        fontSize: "0.85rem !important",
      },
    },
    "&>h4": {
      color: theme.palette.white.main,
      fontWeight: "500",
      fontSize: "1.5rem !important",
      marginRight: "10px",
      cursor: "pointer",
      [theme.breakpoints.down(769)]: {
        fontSize: "1.3rem !important",
      },
      [theme.breakpoints.down(625)]: {
        fontSize: "1.2rem !important",
      },
      [theme.breakpoints.down(553)]: {
        fontSize: "1rem !important",
      },
      [theme.breakpoints.down(405)]: {
        fontSize: "0.85rem !important",
      },
    },
    "&>svg": {
      cursor: "pointer",
      [theme.breakpoints.down(359)]: {
        width: "15px",
        height: "15px",
      },
    },
  },
  pageTwoContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "30px",
    "&>h2": {
      fontSize: "2.625rem",
      fontWeight: "500",
      color: theme.palette.white.main,
      marginBottom: "25px",
      [theme.breakpoints.down(769)]: {
        fontSize: "2.3rem !important",
      },
      [theme.breakpoints.down(660)]: {
        fontSize: "2.1rem !important",
      },
      [theme.breakpoints.down(572)]: {
        fontSize: "1.8rem !important",
      },
      [theme.breakpoints.down(500)]: {
        fontSize: "1.5rem !important",
      },
      [theme.breakpoints.down(415)]: {
        fontSize: "1.3rem !important",
      },
      [theme.breakpoints.down(385)]: {
        fontSize: "1.2rem !important",
      },
      [theme.breakpoints.down(340)]: {
        fontSize: "1rem !important",
      },
    },
  },
  videoItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: "20px",
    "&>h3": {
      fontSize: "1.5rem",
      fontWeight: "500",
      color: "black",
      textDecoration: "underline",
      // marginRight: "40px",
      [theme.breakpoints.down(769)]: {
        fontSize: "1.3rem",
      },
      [theme.breakpoints.down(660)]: {
        fontSize: "1.2rem",
      },
      [theme.breakpoints.down(572)]: {
        fontSize: "1rem",
      },
      [theme.breakpoints.down(500)]: {
        fontSize: "0.8rem",
      },
      [theme.breakpoints.down(415)]: {
        fontSize: "0.7rem",
      },
    },
    "&>div": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      "&>h3": {
        fontSize: "1.5rem",
        fontWeight: "500",
        color: theme.palette.white.main,
        [theme.breakpoints.down(769)]: {
          fontSize: "1.3rem",
        },
        [theme.breakpoints.down(660)]: {
          fontSize: "1.2rem",
        },
        [theme.breakpoints.down(572)]: {
          fontSize: "1rem",
        },
        [theme.breakpoints.down(500)]: {
          fontSize: "0.8rem",
        },
        [theme.breakpoints.down(415)]: {
          fontSize: "0.7rem",
        },
      },
    },
    "&>div:first-child": {
      marginLeft: "90px",
      [theme.breakpoints.down(900)]: {
        marginLeft: "0px",
      },
      "&>svg": {
        [theme.breakpoints.down(415)]: {
          width: "20px",
          height: "20px",
        },
        [theme.breakpoints.down(360)]: {
          width: "15px",
          height: "15px",
        },
      },
    },
    "&>div:last-child": {
      marginRight: "100px",
      [theme.breakpoints.down(900)]: {
        marginRight: "0px",
      },
    },
  },
  correctIcon: {
    "&>h4": {
      fontSize: "1.5rem !important",
      fontWeight: "500",
      color: theme.palette.white.main,
      [theme.breakpoints.down(769)]: {
        fontSize: "1.3rem !important",
      },
      [theme.breakpoints.down(660)]: {
        fontSize: "1.2rem !important",
      },
      [theme.breakpoints.down(572)]: {
        fontSize: "1rem !important",
      },
      [theme.breakpoints.down(500)]: {
        fontSize: "0.8rem !important",
      },
      [theme.breakpoints.down(415)]: {
        fontSize: "0.7rem !important",
      },
    },
    "&>svg": {
      marginRight: "10px",
      [theme.breakpoints.down(769)]: {
        width: "20px",
        height: "20px",
      },
      [theme.breakpoints.down(660)]: {
        width: "18px",
        height: "18px",
      },
      [theme.breakpoints.down(572)]: {
        width: "15px",
        height: "15px",
      },
      [theme.breakpoints.down(500)]: {
        width: "15px",
        height: "15px",
      },
      [theme.breakpoints.down(415)]: {
        width: "15px",
        height: "15px",
      },
      "&>g": {
        "&>path": {
          fill: theme.palette.white.main,
        },
      },
    },
  },
  incomplete: {
    "&>h4": {
      fontSize: "1.5rem !important",
      fontWeight: "500",
      color: "#FF5A5A",
      // color: "white",
      [theme.breakpoints.down(769)]: {
        fontSize: "1.3rem !important",
      },
      [theme.breakpoints.down(660)]: {
        fontSize: "1.2rem !important",
      },
      [theme.breakpoints.down(572)]: {
        fontSize: "1rem !important",
      },
      [theme.breakpoints.down(500)]: {
        fontSize: "0.8rem !important",
      },
      [theme.breakpoints.down(415)]: {
        fontSize: "0.7rem !important",
      },
    },
    "&>svg": {
      "&>g": {
        "&>path": {
          fill: theme.palette.white.main,
        },
      },
    },
  },
  watchNow: {
    marginRight: "9px !important",
    cursor: "pointer",
    [theme.breakpoints.down(769)]: {
      marginRight: "7px !important",
    },
    [theme.breakpoints.down(660)]: {
      marginRight: "0px !important",
    },
  },
  watchNowIncomplete: {
    marginRight: "40px !important",
    cursor: "pointer",
    [theme.breakpoints.down(769)]: {
      marginRight: "40px !important",
    },
    [theme.breakpoints.down(660)]: {
      marginRight: "30px !important",
    },
    [theme.breakpoints.down(580)]: {
      marginRight: "20px !important",
    },
  },
  seeHowPatient: {
    marginRight: "45px !important",
    cursor: "pointer",
    [theme.breakpoints.down(769)]: {
      marginRight: "40px !important",
    },
    [theme.breakpoints.down(660)]: {
      marginRight: "30px !important",
    },
    [theme.breakpoints.down(580)]: {
      marginRight: "20px !important",
    },
  },
  seeHowPatientIncomplete: {
    marginRight: "75px !important",
    cursor: "pointer",
    [theme.breakpoints.down(769)]: {
      marginRight: "70px !important",
    },
    [theme.breakpoints.down(660)]: {
      marginRight: "60px !important",
    },
    [theme.breakpoints.down(580)]: {
      marginRight: "50px !important",
    },
  },
  seeHowRepeat: {
    marginRight: "2px !important",
    cursor: "pointer",
  },
  seeHowRepeatIcomplete: {
    // marginRight: "50px !important",
    marginRight: "33px !important",
    cursor: "pointer",
  },
  progressBar: {
    background: "linear-gradient(90deg, #3A7C05 0%, #7BC044 100%) !important",
  },
  progressBarRoot: {
    width: "98% !important",
    backgroundColor: "white !important",
    height: "40px !important",
    borderRadius: "50px !important",
    [theme.breakpoints.down(660)]: {
      height: "30px !important",
    },

    [theme.breakpoints.down(572)]: {
      height: "25px !important",
    },
    [theme.breakpoints.down(500)]: {
      height: "20px !important",
    },
    [theme.breakpoints.down(415)]: {
      height: "15px !important",
    },
  },
  progressBarMainContainer: {
    width: "713px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "50px",
    [theme.breakpoints.down(769)]: {
      width: "90%",
    },
  },
  progressBarContainer: {
    background: "white",
    position: "relative",
    display: "inline-flex",
    width: "100%",
    height: "50px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50px",
    [theme.breakpoints.down(660)]: {
      height: "40px",
    },
    [theme.breakpoints.down(572)]: {
      height: "35px",
    },
    [theme.breakpoints.down(500)]: {
      height: "30px",
    },
    [theme.breakpoints.down(415)]: {
      height: "25px",
    },
  },
  progressLabelContainer: (props) => ({
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingLeft: `${Math.round(props.progress)}%`,
    width: "100%",
    overflow: `${props.progress < 40 ? "hidden" : "visible"}`,
  }),
  progressLabel: (props) => ({
    transform: `${
      Math.round(props.progress) < 10
        ? "translateX(-100%)"
        : Math.round(props.progress) === 33
        ? "translateX(-120%)"
        : Math.round(props.progress) === 67
        ? "translateX(-150%)"
        : Math.round(props.progress) === 100
        ? "translateX(-150%)"
        : "translateX(-50%)"
    }`,
    whiteSpace: "nowrap",
    maxWidth: `${
      Math.round(props.progress) === 100
        ? "unset"
        : `${100 - Math.round(props.progress)}%`
    }`,
    overflow: `${props.progress < 40 ? "hidden" : "visible"}`,
    fontSize: "1.5rem !important",
    fontWeight: "600 !important",
    color: "white !important",
    position: "absolute",
    left: `${Math.round(props.progress)}%`,
    transition: "left 0.4s linear",
    [theme.breakpoints.down(769)]: {
      fontSize: "1.5rem !important",
    },
    [theme.breakpoints.down(660)]: {
      fontSize: "1.2rem !important",
    },
    [theme.breakpoints.down(572)]: {
      fontSize: "1rem !important",
    },
    [theme.breakpoints.down(500)]: {
      fontSize: "0.8rem !important",
    },
    [theme.breakpoints.down(415)]: {
      fontSize: "0.7rem !important",
    },
  }),
  videoItemContainer: {
    width: "713px",
    [theme.breakpoints.down(780)]: {
      width: "90%",
      marginBottom: "37px",
    },
  },
}));

const WelcomeDialog = (props) => {
  const {
    open,
    setOpen,
    title = "",
    body,
    actionBtnTitle = "",
    handleSubmit = () => {},
    loading = false,
    updateFirstLoginTourAction,
    firstLoginDetails,
    loginUserDetail,
    getLoginUserAction,
  } = props;
  let { width } = useViewport();
  const [page, setPage] = useState(1);
  const [Completed, setCompleted] = useState({
    intro: false,
    patient: false,
    repeat: false,
  });
  const [progress, setProgress] = React.useState(0);
  const [tourType, setTourType] = React.useState("");
  const classes = useStyles({ progress });
  const handleClose = () => {
    setOpen(false);
  };
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const [videoPath, setVideoPath] = useState("");
  const navigate = useNavigate();
  const handleNext = (val) => {
    setPage(2);
    handleTourUpdate("howTo");
    if (val === 1) {
      setPage(1);
    }
  };

  useEffect(() => {
    const calculateProgress = () => {
      const completedSteps = Object.values(Completed).filter(Boolean).length;
      setProgress((completedSteps / 3) * 100);
    };
    calculateProgress();
  }, [Completed]);

  // Tour API call
  const handleTourUpdate = (type) => {
    let payload = {};
    if (type === "howTo") {
      payload.type = "t_is_watch_introduction_video";
      updateFirstLoginTourAction(payload);
    } else if (type === "patients") {
      payload.type = "t_is_import_patient_pmr";
      updateFirstLoginTourAction(payload);
    } else if (type === "order") {
      payload.type = "t_is_create_order";
      updateFirstLoginTourAction(payload);
    } else if (type === "all") {
      payload.type = "all";
      updateFirstLoginTourAction(payload);
    } else {
      return;
    }
  };

  // Tour Success useEffect
  useEffect(() => {
    if (firstLoginDetails?.success) {
      getLoginUserAction();
    }
  }, [firstLoginDetails]);

  // Set Complete Steps useEffect
  useEffect(() => {
    if (loginUserDetail?.success) {
      setCompleted({
        intro:
          loginUserDetail?.data?.pharmacy_detail?.tour
            ?.t_is_watch_introduction_video,
        patient:
          loginUserDetail?.data?.pharmacy_detail?.tour?.t_is_import_patient_pmr,
        repeat: loginUserDetail?.data?.pharmacy_detail?.tour?.t_is_create_order,
      });
      if (
        loginUserDetail?.data?.pharmacy_detail?.tour
          ?.t_is_watch_introduction_video
      ) {
        setPage(2);
      }
    }
  }, [open, loginUserDetail, firstLoginDetails]);

  const openVideoDialog = (type) => {
    if (type === "intro") {
      setVideoPath(process.env.REACT_APP_RS_INTRO_VIDEO);
      setVideoDialogOpen(true);
    } else if (type === "patientPmr") {
      setVideoPath(
        "https://www.loom.com/embed/eac968353cd6457f8cfdce5fa4102d30"
      );
      setVideoDialogOpen(true);
    } else if (type === "repeatOrder") {
      setVideoPath(
        "https://www.loom.com/embed/b5fd1564d2c646f5b251863289882580"
      );
      setVideoDialogOpen(true);
    } else {
      return;
    }
  };
  return (
    <>
      <Dialog
        className={classes.rsDialog}
        maxWidth={"xs"}
        open={open}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <Box className={classes.container}>
          <Box className={classes.ModalHeading}>
            {/* <Typography onClick={() => handleNext(1)}>pre</Typography> */}

            <IconButton
              aria-label="close"
              onClick={handleClose}
              className={classes.closeIconBtn}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <DialogContent className={classes.dialogContent}>
            {page === 1 && (
              <Box className={classes.pageOneContainer}>
                <Box>
                  <PrimaryIcon
                    icon={DoctorWithPill}
                    // width="260px"
                    // height="500px"
                    // width="246px"
                    // height="474px"
                  />
                </Box>
                <Box>
                  <Typography variant="h1">
                    Hi, Welcome to Repeatsmart
                  </Typography>
                  <Typography variant="h2">
                    Would you like to view the introduction video?
                  </Typography>
                  <Box className={classes.watchVideoContainer}>
                    <Box
                      className={classes.watchVideo}
                      onClick={() => {
                        openVideoDialog("intro");
                        handleTourUpdate("howTo");
                        // setVideoDialogOpen(true);
                      }}
                    >
                      <PrimaryIcon
                        icon={VideoIcon}
                        width="20px"
                        height="20px"
                        // onClick={() => {
                        //   setVideoDialogOpen(true);
                        // }}
                      />
                      <Typography
                        // onClick={() => {
                        //   setVideoDialogOpen(true);
                        // }}
                        variant="h5"
                      >
                        Watch Video
                      </Typography>
                    </Box>
                    <Typography
                      variant="h5"
                      onClick={() => {
                        handleNext()
                        // setPage(2);
                      }}
                    >
                      Not now
                    </Typography>
                  </Box>
                  {/* <FormGroup className={classes.dontShowCheckbox}>
                    <FormControlLabel
                      // label={"Don’t show this to me again"}
                      label={"Don’t show me this again"}
                      control={
                        <Checkbox
                          color="primary"
                          // checked={item?.action ? item?.action : false}
                          // onChange={(e, value) => {}}
                        />
                      }
                    />
                  </FormGroup> */}
                </Box>
              </Box>
            )}

            {page === 2 && (
              <Box className={classes.pageTwoContainer}>
                <Typography variant="h2">
                  Getting started with Repeatsmart
                </Typography>
                <Box className={classes.progressBarMainContainer}>
                  <Box className={classes.progressBarContainer}>
                    <LinearProgress
                      variant="determinate"
                      value={progress}
                      className={classes.progressBarRoot}
                      classes={{
                        bar: classes.progressBar,
                      }}
                    />
                    <Box className={classes.progressLabelContainer}>
                      <Typography
                        variant="body2"
                        className={classes.progressLabel}
                      >
                        {`${Math.round(progress)}%`}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                {width < 900 ? (
                  <Box className={classes.videoItemContainer}>
                    <Box className={classes.videoItem}>
                      <Box>
                        <ArrowRight />
                        <Typography variant="h3">
                          Watch introduction video
                        </Typography>
                      </Box>
                      <Typography
                        variant="h3"
                        className={
                          // classes.watchNow
                          Completed.intro === true
                            ? classes.watchNow
                            : classes.watchNowIncomplete
                        }
                        onClick={() => {
                          // navigate("/how-to");
                          // setVideoDialogOpen(true);
                          openVideoDialog("intro");
                          handleTourUpdate("howTo");
                        }}
                      >
                        Watch Now
                      </Typography>
                      <Box
                        className={
                          Completed.intro === true
                            ? classes.correctIcon
                            : classes.incomplete
                        }
                      >
                        {Completed.intro === true && <CorrectIcon />}
                        <Typography variant="h4">
                          {Completed.intro === true
                            ? "Completed"
                            : "Incomplete"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box className={classes.videoItem}>
                      <Box>
                        <ArrowRight />
                        <Typography variant="h3">
                          Import patients from PMR
                        </Typography>
                      </Box>
                      <Typography
                        variant="h3"
                        className={
                          // classes.seeHowPatient
                          Completed.patient === true
                            ? classes.seeHowPatient
                            : classes.seeHowPatientIncomplete
                        }
                        onClick={() => {
                          // navigate("/patients");
                          // handleClose();
                          openVideoDialog("patientPmr");
                          handleTourUpdate("patients");
                        }}
                      >
                        See How
                      </Typography>
                      <Box
                        className={
                          Completed.patient === true
                            ? classes.correctIcon
                            : classes.incomplete
                        }
                      >
                        {Completed.patient === true && <CorrectIcon />}
                        <Typography variant="h4">
                          {Completed.patient === true
                            ? "Completed"
                            : "Incomplete"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box className={classes.videoItem}>
                      <Box>
                        <ArrowRight />
                        <Typography variant="h3">
                          Create Repeat Orders
                        </Typography>
                      </Box>
                      <Typography
                        variant="h3"
                        className={
                          Completed.repeat === true
                            ? classes.seeHowRepeat
                            : classes.seeHowRepeatIcomplete
                        }
                        onClick={() => {
                          // navigate("/order");
                          // handleClose();
                          openVideoDialog("repeatOrder");
                          handleTourUpdate("order");
                        }}
                      >
                        See How
                      </Typography>
                      <Box
                        className={
                          Completed.repeat === true
                            ? classes.correctIcon
                            : classes.incomplete
                        }
                      >
                        {Completed.repeat === true && <CorrectIcon />}
                        <Typography variant="h4">
                          {Completed.repeat === true
                            ? "Completed"
                            : "Incomplete"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ) : (
                  <>
                    <Box className={classes.videoItem}>
                      <Box>
                        <ArrowRight />
                        <Typography variant="h3">
                          Watch introduction video
                        </Typography>
                      </Box>
                      <Typography
                        variant="h3"
                        className={
                          // classes.watchNow
                          Completed.intro === true
                            ? classes.watchNow
                            : classes.watchNowIncomplete
                        }
                        onClick={() => {
                          // navigate("/how-to");
                          // setVideoDialogOpen(true);
                          openVideoDialog("intro");
                          handleTourUpdate("howTo");
                        }}
                      >
                        Watch Now
                      </Typography>
                      <Box
                        className={
                          Completed.intro === true
                            ? classes.correctIcon
                            : classes.incomplete
                        }
                      >
                        {Completed.intro === true && <CorrectIcon />}
                        <Typography variant="h4">
                          {Completed.intro === true
                            ? "Completed"
                            : "Incomplete"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box className={classes.videoItem}>
                      <Box>
                        <ArrowRight />
                        <Typography variant="h3">
                          Import patients from PMR
                        </Typography>
                      </Box>
                      <Typography
                        variant="h3"
                        className={
                          // classes.seeHowPatient
                          Completed.patient === true
                            ? classes.seeHowPatient
                            : classes.seeHowPatientIncomplete
                        }
                        onClick={() => {
                          // navigate("/patients");
                          openVideoDialog("patientPmr");
                          handleTourUpdate("patients");
                          // handleClose();
                        }}
                      >
                        See How
                      </Typography>
                      <Box
                        className={
                          Completed.patient === true
                            ? classes.correctIcon
                            : classes.incomplete
                        }
                      >
                        {Completed.patient === true && <CorrectIcon />}
                        <Typography variant="h4">
                          {Completed.patient === true
                            ? "Completed"
                            : "Incomplete"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box className={classes.videoItem}>
                      <Box>
                        <ArrowRight />
                        <Typography variant="h3">
                          Create Repeat Orders
                        </Typography>
                      </Box>
                      <Typography
                        variant="h3"
                        className={
                          Completed.repeat === true
                            ? classes.seeHowRepeat
                            : classes.seeHowRepeatIcomplete
                        }
                        onClick={() => {
                          // navigate("/order");
                          openVideoDialog("repeatOrder");
                          setTourType("repeatOrder")
                          // handleTourUpdate("order");
                          // handleClose();
                        }}
                      >
                        See How
                      </Typography>
                      <Box
                        className={
                          Completed.repeat === true
                            ? classes.correctIcon
                            : classes.incomplete
                        }
                      >
                        {Completed.repeat === true && <CorrectIcon />}
                        <Typography variant="h4">
                          {Completed.repeat === true
                            ? "Completed"
                            : "Incomplete"}
                        </Typography>
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
            )}
          </DialogContent>
          <Box className={classes.pagination}>
            <Typography variant="h3">{page} of 2</Typography>
            <Typography
              variant="h4"
              onClick={() => {
                if (page === 1) {
                  handleNext();
                } else {
                  handleTourUpdate("all");
                  handleClose();
                }
              }}
            >
              {page === 1 ? "Next" : "Finish"}
            </Typography>
            <ArrowNext
              onClick={() => {
                if (page === 1) {
                  handleNext();
                } else {
                  handleTourUpdate("all");
                  handleClose();
                }
              }}
            />
          </Box>
        </Box>
        <VideoDialog
          open={videoDialogOpen}
          setOpen={setVideoDialogOpen}
          videoPath={videoPath}
          tourType={tourType}
          handleTourUpdate={handleTourUpdate}
        />
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  loginUserDetail: state.user.loginUserDetail.data,
  firstLoginDetails: state.user.firstLoginDetails.data,
});

const mapDispatchToProps = (dispatch) => ({
  getLoginUserAction: () => dispatch({ type: START_GET_LOGIN_USER }),
  updateFirstLoginTourAction: (payload) =>
    dispatch({ type: START_UPDATE_FIRST_LOGIN_TOUR, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeDialog);
